import routerOptions0 from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/node_modules/.pnpm/nuxt@3.12.1_@parcel+watcher@2.5.0_@types+node@22.13.10_bufferutil@4.0.9_db0@0.2.1_eslin_cae75c569e017aa238f57f071e372c70/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}